import React, { FC } from 'react';

import { Text, TextTag, TextWeight } from '@/shared/components/Text';
import { useI18n } from '@/app/hooks/useI18n';
import { Link } from '@/shared/components/Link/Link';
import { useLegal } from '@/app/hooks/useLegal';
import { useSocials } from '@/app/hooks/useSocials';
import { useClientSupport } from '@/shared/hooks/useClientSupport';

import { Copyright } from '../Copyright/Copyright';

import styles from './Footer.module.css';

export const Footer: FC = () => {
    const i18n = useI18n();

    const legalLink = useLegal();

    const { clientSupportLink } = useClientSupport();

    const socialLinks = useSocials();

    return (
        <footer className={styles.root}>
            <div className={styles.content}>
                <div className={styles.socialNetworks}>
                    {socialLinks.map(({ link, renderIcon, label }) => (
                        <Link
                            key={label}
                            href={link}
                            className={styles.socialLink}
                            target="_blank"
                            rel="noreferrer"
                            aria-label={label}
                        >
                            {renderIcon()}
                        </Link>
                    ))}
                </div>
                <div className={styles.support}>
                    <Text className={styles.supportText}>{i18n('footer_support_text')}</Text>
                    {clientSupportLink && (
                        <Link
                            className={styles.supportButton}
                            href={clientSupportLink}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <Text
                                className={styles.supportLink}
                                tag={TextTag.Span}
                                weight={TextWeight.Medium}
                            >
                                {i18n('footer_contact_support_text')}
                            </Text>
                        </Link>
                    )}
                </div>
                <div className={styles.copyrights}>
                    <Copyright className={styles.copyrightsText} />
                    <Link
                        href={legalLink}
                        rel="noopener noreferrer"
                        className={styles.copyrightsLink}
                        target="_blank"
                    >
                        {i18n('footer_legal_link')}
                    </Link>
                </div>
            </div>
        </footer>
    );
};
